import { useMemo } from "react";

const DOC_BASE_URL = `https://docgenerator.candy.it/docgenerator`;

const useEnergyLabelLink = (
  { key_prod: productId, pageLine: { lineConfigurationFieldSet }, lineId, energyLabelCav, manuals },
  LANG,
  config
) => {
  const { isNewEnergyLabelEu, isNewEnergyLabelUk } = lineConfigurationFieldSet;

  const oldLines = config.haierStEcommLines.productLine;

  const energyLabelUrl = useMemo(() => {
    if (!lineId) return null;
    const isOld = oldLines.includes(`${lineId}`);
    return `${DOC_BASE_URL}/${isOld ? `energylabel?lan=${LANG}` : "newenergylabel?"}`;
  }, [lineId, LANG, oldLines]);

  const check8815 =
    (oldLines.includes(`${lineId}`) || lineId === 666 || lineId === 17) &&
    manuals?.find((item) => item?.type === 8815 && item?.filename?.startsWith("http"));
  const check8816 =
    (!oldLines.includes(`${lineId}`) || lineId === 666 || lineId === 17) &&
    manuals?.find((item) => item?.type === 8816 && item?.filename?.startsWith("http"));
  const check8825 =
    (oldLines.includes(`${lineId}`) || lineId === 666 || lineId === 17) &&
    manuals?.find((item) => item?.type === 8825 && item?.filename?.startsWith("http"));
  const check8826 =
    (!oldLines.includes(`${lineId}`) || lineId === 666 || lineId === 17) &&
    manuals?.find((item) => item?.type === 8826 && item?.filename?.startsWith("http"));
  const manual8815 = manuals?.find(
    (item) => item?.type === 8815 && item?.filename?.startsWith("http")
  )?.filename;
  const manual8816 = manuals?.find(
    (item) => item?.type === 8816 && item?.filename?.startsWith("http")
  )?.filename;
  const manual8825 = manuals?.find(
    (item) => item?.type === 8825 && item?.filename?.startsWith("http")
  )?.filename;
  const manual8826 = manuals?.find(
    (item) => item?.type === 8826 && item?.filename?.startsWith("http")
  )?.filename;

  const energyLabelCavLink = useMemo(() => {
    if (!(energyLabelCav > 0) && check8815 && check8816 && (lineId === 666 || lineId === 17)) {
      return [
        {
          url: manual8815,
        },
        {
          url: manual8816,
        },
      ];
    } else if (check8815 && !(energyLabelCav > 0)) {
      return [
        {
          url: manual8815,
        },
      ];
    } else if (check8816 && !(energyLabelCav > 0)) {
      return [
        {
          url: manual8816,
        },
      ];
    } else if (energyLabelCav > 0) {
      const res = [];
      for (let index = 0; index < energyLabelCav; index++) {
        res.push({
          url: check8815
            ? manual8815
            : check8816
            ? manual8816
            : `${energyLabelUrl}&cav=${index + 1}`,
        });
      }
      return res;
    } else {
      return [{ url: energyLabelUrl }];
    }
  }, [energyLabelCav, energyLabelUrl, manual8815, manual8816, check8815, check8816, lineId]);

  if (isNewEnergyLabelUk && !!isNewEnergyLabelUk?.length && lineId !== 666 && lineId !== 17) {
    return check8825
      ? manual8825
      : check8826
      ? manual8826
      : `${energyLabelUrl}&mkt=UK&sku=${productId}`;
  } else if (isNewEnergyLabelUk && !!isNewEnergyLabelUk?.length && (check8825 || check8826)) {
    return check8825 ? manual8825 : manual8826;
  } else if (
    isNewEnergyLabelEu &&
    !!isNewEnergyLabelEu?.length &&
    lineId !== 666 &&
    lineId !== 17
  ) {
    return check8815 || check8816
      ? energyLabelCavLink?.[0]?.url
      : `${energyLabelCavLink?.[0].url}&mkt=EU&sku=${productId}`;
  } else if (isNewEnergyLabelEu && !!isNewEnergyLabelEu?.length && (check8815 || check8816)) {
    return energyLabelCavLink?.[0]?.url;
  } else {
    return "";
  }
};

export default useEnergyLabelLink;
